module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/dove.svg?2126b1aa48e056d10a16c4c1ce9e691c";